import routes from "constants/routes";
import {
  HTTP_STATUS_MESSAGES,
  NETWORK_ERROR_MESSAGE,
} from "constants/apiErrorMessages";
import { camelizeKeys, tokenUtils } from "utils";

const extractErrorMessage = (response, json) => {
  if (!json) {
    return HTTP_STATUS_MESSAGES[response.status] || "An unknown error occurred";
  }

  if (Array.isArray(json.detail)) {
    return json.detail
      .map((item) => {
        if (typeof item === "string") return item;
        if (!item || typeof item !== "object") return String(item);

        const fieldPath = Array.isArray(item.loc)
          ? item.loc.filter((part) => part !== "body").join(".")
          : "";
        const message = item.msg || "Unknown error";

        return fieldPath ? `${fieldPath}: ${message}` : message;
      })
      .join(", ");
  }

  if (typeof json.detail === "string") return json.detail;
  if (json.message) return json.message;

  return HTTP_STATUS_MESSAGES[response.status] || "An unknown error occurred";
};

const fetchJSON = async (url, options = {}) => {
  const token = tokenUtils.getToken();

  const newOptions = {
    method: options.method,
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
  };

  if (options.body) {
    if (options.body instanceof FormData) {
      delete newOptions.headers["Content-Type"];
      newOptions.body = options.body;
    } else {
      newOptions.body = JSON.stringify(options.body);
    }
  }

  try {
    const response = await fetch(url, newOptions);
    const json = await response.json().catch(() => null);

    if (!response.ok) {
      if (response.status === 401) {
        tokenUtils.deleteToken();
        window.location.href = `${routes.login.root}?redirect=${window.location.pathname}`;
        return;
      }

      const message = extractErrorMessage(response, json);
      throw {
        statusCode: response.status,
        statusText: response.statusText,
        message,
        data: json || null,
      };
    }

    return {
      statusCode: response.status,
      statusText: response.statusText,
      ...camelizeKeys(json || {}),
    };
  } catch (error) {
    if (error?.statusCode) {
      throw error;
    }

    throw {
      statusCode: 0,
      message: error?.message || NETWORK_ERROR_MESSAGE,
      data: null,
    };
  }
};

export default fetchJSON;
